import { apiConfig } from '@/services/api-config';

export const getLinkTermCommitmentbyCdAgentCarNumber = async (tokenKey: string, cdAgent: number, carNumber: string) => apiConfig
  .get(`api/TermCommitment/get-document?tokenKey=${tokenKey}&cdAgent=${cdAgent}&carNumber=${carNumber}`)
  .then((response) => response.data)
  .catch(() => []);
